import request from '@/utils/request'

export interface IUser {
  id: number
  openid: string
  name: string
  phone: string
  sex: string
  avatar: string
  idNumber: string
  createTime: string
  balance?: number
  inviterId?: number
  inviterName?: string
  inviterPhone?: string
  waterQuotaRemaining?: number
  /** 欠空桶数（送水 − 回收，历史累计） */
  emptyBucketOutstanding?: number
  /** 本店备注 */
  remark?: string
  /** 地址簿默认地址 */
  defaultAddress?: string
  /** 地址簿总数 */
  addressCount?: number
  /** 其它地址（悬停） */
  otherAddresses?: string[]
}

export interface IUserCouponRecord {
  id: number
  couponId: number
  name: string
  amount: number
  minAmount: number
  storeId?: number
  status: number
  validFrom?: string
  validTo?: string
  expireTime?: string
}

export interface IUserWaterQuota {
  id: number
  storeId?: number
  storeName?: string
  remainingBuckets: number
  totalGranted: number
  updateTime?: string
}

export interface IWaterVoucherPurchase {
  id: number
  orderId: number
  orderNumber?: string
  configId: number
  configName?: string
  bucketsGranted: number
  payAmount: number
  inviterReward: number
  status: number
  createTime?: string
}

export interface IUserWaterBucketUse {
  orderId: number
  orderNumber?: string
  bucketsUsed: number
  amount?: number
  status?: number
  statusLabel?: string
  orderTime?: string
}

export interface IUserCourierAssign {
  orderId: number
  orderNumber?: string
  courierId?: number
  courierName?: string
  courierPhone?: string
  assignTime?: string
  status?: number
  statusLabel?: string
  address?: string
  orderTime?: string
}

export function getUserPage(params: {
  pageNum: number
  pageSize: number
  storeId?: number | string
  name?: string
  phone?: string
  inviterPhone?: string
  orderBy?: string
  sortOrder?: string
}) {
  return request({
    url: '/user/page',
    method: 'get',
    params
  })
}

export function updateUserRemark(userId: number, data: { storeId?: number | string; remark?: string }) {
  return request({
    url: `/user/${userId}/remark`,
    method: 'put',
    data
  })
}

export function getUserCouponRecords(userId: number, params: { status?: number } = {}) {
  return request({
    url: `/user/${userId}/coupons`,
    method: 'get',
    params
  })
}

export function getUserWaterQuotas(userId: number) {
  return request({
    url: `/user/${userId}/waterQuotas`,
    method: 'get'
  })
}

export function getUserWaterVoucherPurchases(userId: number) {
  return request({
    url: `/user/${userId}/waterVoucherPurchases`,
    method: 'get'
  })
}

export function getUserWaterBucketUses(userId: number) {
  return request({
    url: `/user/${userId}/waterBucketUses`,
    method: 'get'
  })
}

export function getUserCourierAssignments(userId: number) {
  return request({
    url: `/user/${userId}/courierAssignments`,
    method: 'get'
  })
}

export function getUserEmptyBucketRecords(userId: number) {
  return request({
    url: `/user/${userId}/emptyBucketRecords`,
    method: 'get'
  })
}
